import { render, staticRenderFns } from "./NewLeadSidebar.vue?vue&type=template&id=910c0f0a&scoped=true"
import script from "./NewLeadSidebar.vue?vue&type=script&lang=js"
export * from "./NewLeadSidebar.vue?vue&type=script&lang=js"
import style0 from "./NewLeadSidebar.vue?vue&type=style&index=0&id=910c0f0a&prod&lang=scss&scoped=true"
import style1 from "./NewLeadSidebar.vue?vue&type=style&index=1&id=910c0f0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910c0f0a",
  null
  
)

export default component.exports